import { ExternalLink, Sparkles } from 'lucide-react';

export default function Hyperlinks({ isOpen, onToggle }) {
  const trustlyLinks = [
    {
      title: 'Casino med Trustly',
      url: 'https://site.com/casino-med-trustly',
      description: 'Hovedside om Trustly casinoer'
    },
    {
      title: 'Trustly Hurtig Udbetaling',
      url: 'https://site.com/trustly-hurtig-udbetaling',
      description: 'Guide til hurtige udbetalinger'
    }
  ];

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={onToggle}
        className={`fixed bottom-24 right-1 sm:w-16 sm:h-16 w-16 h-16 bg-gradient-to-tr from-emerald-500 to-green-500 text-white rounded-full shadow-lg flex items-center justify-center z-50 transition-transform duration-300 hover:scale-110`}
        aria-label="Trustly Links"
      >
        {/* Animate Trustly Icon */}
        <div className="relative w-6 h-6">
          <Sparkles
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-0 scale-50 rotate-[360deg]' : 'opacity-100 scale-100 animate-pulse'
            }`}
          />
          <ExternalLink
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-50 -rotate-[360deg]'
            }`}
          />
        </div>
      </button>

      {/* Popup Box */}
      <div
        className={`fixed bottom-20 right-16 w-72 z-40 transition-all duration-500 ease-out ${
          isOpen ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-4 opacity-0 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-white rounded-xl shadow-2xl border border-emerald-200 overflow-hidden transform transition-all duration-500">
          {/* Header */}
          <div
            className={`bg-gradient-to-r from-emerald-500 to-green-500 text-white p-4 text-center relative transition-all duration-500 rounded-t-xl ${
              isOpen ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
              <Sparkles className="w-5 h-5" />
              <div className="text-lg font-bold">Trustly Links</div>
            </div>
            <div className="text-sm opacity-90 mt-1">Hurtige udbetaling ressourcer</div>

            <button
              onClick={onToggle}
              className="absolute top-2 right-2 text-white hover:text-gray-200 transition-all duration-300 p-1 hover:rotate-90 hover:scale-110"
              aria-label="Luk"
            >
              <ExternalLink className="w-4 h-4" />
            </button>
          </div>

          {/* Links Content */}
          <div
            className={`p-4 space-y-3 transition-all duration-500 ${
              isOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
            }`}
          >
            {trustlyLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block p-3 rounded-lg border border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50 transition-all duration-300 group"
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    <div className="text-emerald-800 font-semibold text-sm group-hover:text-emerald-900 transition-colors duration-300">
                      {link.title}
                    </div>
                    <div className="text-xs text-gray-600 mt-1">
                      {link.description}
                    </div>
                  </div>
                  <ExternalLink 
                    size={16} 
                    className="text-emerald-600 group-hover:text-emerald-800 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 flex-shrink-0 mt-0.5"
                  />
                </div>
              </a>
            ))}

            {/* Additional Info */}
            <div className="pt-3 border-t border-emerald-200">
              <p className="text-xs text-gray-600 text-center">
                Trustly tilbyder hurtige og sikre udbetalinger på 0-15 minutter
              </p>
            </div>
          </div>

          {/* Bottom Gradient Line */}
          <div
            className={`h-1 bg-gradient-to-r from-emerald-500 to-green-500 transition-all duration-700 ${
              isOpen ? 'w-full' : 'w-0'
            }`}
          />
        </div>
      </div>
    </>
  );
}